export default __webpack_public_path__ + "static/Assessment_Policy_and_Procedures_for_ROSA_final-7a77552c6f8348207daa8a272c88e3d6.pdf";